import { render, staticRenderFns } from "./datosCupon.vue?vue&type=template&id=6d101b2e&scoped=true&"
import script from "./datosCupon.vue?vue&type=script&lang=js&"
export * from "./datosCupon.vue?vue&type=script&lang=js&"
import style0 from "./datosCupon.vue?vue&type=style&index=0&id=6d101b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d101b2e",
  null
  
)

export default component.exports